import React from 'react';

const PRESETS = [
  { label: '7 nap', days: 7 },
  { label: '30 nap', days: 30 },
  { label: '90 nap', days: 90 },
  { label: 'Idén', days: 'ytd' },
];

function fmt(d) { return d.toISOString().split('T')[0]; }

export default function DateRange({ from, to, onChange }) {
  const apply = (days) => {
    const t = new Date();
    let f;
    if (days === 'ytd') { f = new Date(t.getFullYear(), 0, 1); }
    else { f = new Date(t); f.setDate(f.getDate() - days); }
    onChange(fmt(f), fmt(t));
  };

  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
      {PRESETS.map(p => (
        <button key={p.label} onClick={() => apply(p.days)}
          style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid #2a2e3a', color: '#00d4ff', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>
          {p.label}
        </button>
      ))}
      <input type="date" value={from} onChange={e => onChange(e.target.value, to)} style={{ fontSize: 12, padding: '6px 8px' }} />
      <span style={{ color: '#8b8fa3' }}>–</span>
      <input type="date" value={to} onChange={e => onChange(from, e.target.value)} style={{ fontSize: 12, padding: '6px 8px' }} />
    </div>
  );
}
